import type { OAuthRepository } from './oauth.repository'
import type { OAuthAuthorizeCompleteDto } from './dto/oauth-authorize-complete.dto'

export class OAuthService {
    constructor(private rep: OAuthRepository) {}

    async authorizeComplete(dto: OAuthAuthorizeCompleteDto): Promise<{ redirectUri: string }> {
        return await this.rep.authorizeComplete(dto)
    }
}
